import { setDocument, updateDocument } from 'db/mutations';
import { getDocument } from 'db/queries';
import { getUserId } from 'services/auth';
import normalize from 'utils/normalize';
import { COLLECTION_NAME } from '.';

export const updateUser = async (userData) => {
  const userId = getUserId();

  if (!userId) {
    throw new Error('User not authenticated');
  }

  return updateDocument(COLLECTION_NAME, userId, userData).then(() => ({
    message: 'User updated successfully',
    success: true,
  }));
};

export const existsHandle = async (username) => {
  if (!username) return false;

  const handle = normalize(username).replace(/[^a-zA-Z0-9]/g, '');
  const user = await getDocument('handles', handle);

  return !!user;
};

export const updateHandle = async (username, uid) => {
  const userId = uid || getUserId();

  if (!userId) throw new Error('User not authenticated');

  const handle = normalize(username).replace(/[^a-zA-Z0-9]/g, '');
  const exists = await existsHandle(handle);

  if (exists) {
    return {
      message: 'Handle already exists',
      success: false,
    };
  }

  await setDocument('handles', handle, {
    uid: userId,
  });

  return updateDocument(COLLECTION_NAME, userId, {
    handle,
  }).then(() => ({ message: 'Handle updated successfully', success: true }));
};
